import { clsx } from 'clsx'

import { FC, forwardRef, LegacyRef } from 'react'

import { IconArrow } from '@/app/shared/icons'
import { IClassName } from '@/app/shared/interfaces/common.interface'
import { ButtonComponent } from '@/app/shared/ui/button'

// interface
interface ISliderArrow extends IClassName {
  ref?: LegacyRef<any>
  button: 'prev' | 'next'
  onClick?: () => void
  classSize?: string
  classSizeIcon?: string
}

// component
const SliderArrowComponent: FC<Readonly<ISliderArrow>> = forwardRef(
  ({ className, button, onClick, classSize, classSizeIcon, ...props }, ref) => {
    const rotateClass = button === 'next' ? '-rotate-90' : 'rotate-90'

    // return
    return (
      <ButtonComponent
        {...props}
        ref={ref}
        color={'primary'}
        className={clsx(
          'flex min-h-0 min-w-0 items-center justify-center rounded-full border-2 border-secondary p-0 text-secondary laptop:cursor-pointer',
          className,
          rotateClass,
          classSize ? classSize : 'h-[80px] w-[80px] laptop:h-[97px] laptop:w-[97px]',
        )}
        onClick={onClick}
      >
        <IconArrow
          className={clsx(
            'flex-shrink-0 text-inherit',
            classSizeIcon ? classSizeIcon : 'h-[34px] w-[45px] laptop:h-[41px] laptop:w-[55px]',
          )}
        />
      </ButtonComponent>
    )
  },
)

SliderArrowComponent.displayName = 'SliderArrowComponent'

export default SliderArrowComponent
